import React, { Component, Fragment } from 'react';
import TimeSingle from './single';

class TimeRange extends Component {
    render() {
        const {
            onStart,
            onStop,
            valueType,
            onStartSelectTime,
            onStopSelectTime
        } = this.props;
        return (
            <div className='timepicker-container'>
                <TimeSingle start={0} stop={23} selectedTime={onStart} valueType={valueType} handleOnChange={onStartSelectTime}/>
                ~
                <TimeSingle start={1} stop={24} selectedTime={onStop} valueType={valueType} handleOnChange={onStopSelectTime}/>
            </div>
        );
    }
}

export default TimeRange;


// WEBPACK FOOTER //
// ./src/components/timelist/range.js